<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, TEXT_FONT_FAMILY} from '../../../../../components/Data/FactorCharts/chartStyle'

export default {
  name: 'VOCsCategoryBarChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render ({factorGroups, dataTimes, unit}) {
      let {data} = this
      let dataMap = data.data
      let {siteName} = data
      let chartOpt = {
        title: {
          text: siteName,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          formatter: (param) => {
            let dataTime = param[0].name
            return `<div style="min-width: 180px;">
              <span style="display: inline-block; margin: 3px; font-weight: bold;">${dataTime}</span>
              ${param.map(el => {
    return `
                  <div style="display: flex;justify-content: space-between;align-items: center;padding: 2px;">
                  <span>${el.marker}${el.seriesName}</span>
                  <span><span style="font-weight: bold;">${el.value}</span>${(el.data && el.data.isHaveIntegral) ? '(重积分)' : ''}</span>
                </div>
                `
  }).join('')}
            </div>`
          }
        },
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll'
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'value',
          name: unit,
          axisLine: {
            show: false
            // lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        dataZoom: [{
          type: 'inside',
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: factorGroups.map(factorGroup => {
          let factorGroupId = factorGroup.id

          return {
            name: factorGroup.name,
            type: 'bar',
            stack: siteName,
            barMaxWidth: 30,
            data: dataTimes.map(dataTime => {
              let data = dataMap[dataTime][factorGroupId]
              return {
                isHaveIntegral: data && data.isHaveIntegral ? data.isHaveIntegral : false,
                value: data && Number.isFinite(data.value) ? Number(data.value.toFixed(3)) : '--'
              }
            })
          }
        })
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/03VOCs-Category-Compare/VOCsCategoryBarChart.vue